document.addEventListener("DOMContentLoaded", () => {
  require.context("assets/images", true);
});
// require.context('@fortawesome/fontawesome-pro/svgs', true)
// require.context('@fortawesome/fontawesome-pro/webfonts', true)
